import { TinyEmitter } from 'tiny-emitter'

// Add unsubscribe patch
class TinyEmitterUnsubscribe extends TinyEmitter
{
	constructor()
	{
		super()
	}

	onWithUnsubscribe(eventName: string, callback: Function, ctx?: any) {
		this.on(eventName, callback, ctx);
		return () => this.off(eventName, callback);
	}

	onceWithUnsubscribe(eventName: string, callback: Function, ctx?: any) {
		this.once(eventName, callback, ctx);
		return () => this.off(eventName, callback);
	}
}

let emitter = new TinyEmitterUnsubscribe()

export function $on(eventName: string, callback: Function, ctx?: any) { return emitter.on(eventName, callback, ctx); }
export function $once(eventName: string, callback: Function, ctx?: any) { return emitter.once(eventName, callback, ctx); }
export function $off(eventName: string, callback?: Function) { return emitter.off(eventName, callback); }
export function $emit(eventName: string, ...args: any[]) { return emitter.emit(eventName, ...args); }
export function $onWithUnsubscribe(eventName: string, callback: Function, ctx?: any) { return emitter.onWithUnsubscribe(eventName, callback, ctx); }
export function $onceWithUnsubscribe(eventName: string, callback: Function, ctx?: any) { return emitter.onceWithUnsubscribe(eventName, callback, ctx); }